import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

import { FaCircle } from 'react-icons/fa';
import { LuMoveDown } from 'react-icons/lu';

import ExpertiseSection from '../components/ExpertiseSection';
import StudioSection from '../components/StudioSection';

import heroSection1 from '../Images/heroSection1.jpg';
import heroSection2 from '../Images/heroSection2.jpg';
import heroSection3 from '../Images/heroSection3.jpg';
import heroSection4 from '../Images/heroSection4.jpg';
import architecture from '../Images/Architecture.jpg';
import PeopleImg from '../Images/People.jpg';



function Home() {
    const images = [heroSection2, heroSection1, heroSection3, heroSection4];
    const [currentIndex, setCurrentIndex] = useState(0);

    const nextImage = () => {
        setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
    };

    useEffect(() => {
        const interval = setInterval(nextImage, 5000);
        return () => clearInterval(interval);
    });

    const goToSlide = (slideIndex) => {
        setCurrentIndex(slideIndex);
    };

    const scrollToSection = (sectionId) => {
        const element = document.getElementById(sectionId);
        if (element) {
            element.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    };

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className='bg-[#1a1a1a]'>
            <div id='backToTop' className=' relative'>
                <img src={images[currentIndex]} alt="Carousel" className="w-full h-[85vh] sm:h-screen md:h-[630px] lg:h-[630px] object-cover" />
                <div className='flex'>
                    {/* <button onClick={prevImage} className="absolute left-4 top-1/2 transform -translate-y-1/2 text-white">
                        <FaChevronCircleLeft className='h-8 sm:h-4 md:h-8 w-8 md:w-8 sm:w-4'/>
                    </button>
                     <button onClick={nextImage} className="absolute right-4 top-1/2 transform -translate-y-1/2 text-white">
                        <FaChevronCircleRight className='h-8 sm:h-4 md:h-8 w-8 md:w-8 sm:w-4'/>
                    </button> */}
                    <button onClick={() => scrollToSection('welcomeSection')} className="absolute right-4 top-1/2 flex items-center justify-center px-5 py-20 -translate-y-1/2 bg-black/40 text-white rounded-full shadow-lg transform hover:bg-black/25 transition duration-200">
                        <LuMoveDown />
                    </button>
                </div>
                <div className="px-6 ">
                    <div className="bg-white/20 px-2 py-1 rounded-full absolute left-1/2 bottom-8 -translate-y-1/2 -translate-x-1/2 flex justify-center space-x-2 mt-4">
                        {images.map((_, index) => (
                            <FaCircle key={index} onClick={() => goToSlide(index)} className={`cursor-pointer text-white text-xs ${index === currentIndex ? ' text-opacity-100 px-3 bg-white/80 rounded-full' : 'text-opacity-50'}`} />
                        ))}
                    </div>
                </div>
            </div>

            <div id="welcomeSection" className="px-4 md:px-16 py-20 text-white bg-[#333333] mb-14">
                <div className="flex flex-col md:flex-row justify-center items-center space-y-8 md:space-y-0 md:space-x-4">
                    <div className="text-center md:text-right mb-4 md:mb-0 md:mr-8">
                        <h1 className="text-3xl md:text-4xl font-bold leading-tight tracking-wide">
                            Welcome To <br /> Architetive Designs
                        </h1>
                    </div>
                    <div className="border-l-4 rounded-full border-[#655560] h-20 hidden md:block" />
                    <div className="max-w-xl md:max-w-2xl">
                        <p className="text-center md:text-left font-light">
                            <strong>Architetive Designs</strong> is a well-known Engineering and Architecture firm based in Assam, India. We offer a wide range of services including Architectural Design, Interior Design, Project Management, and Construction Supervision.
                        </p>
                    </div>
                </div>
            </div>

            <StudioSection />

            <div className="w-full px-4 md:px-14 text-white mb-14">
                <h1 className="text-3xl md:text-4xl font-bold mb-8">Architecture</h1>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
                    <div className="relative col-span-1 md:col-span-2 rounded-lg overflow-hidden transition-transform duration-300 ease-in-out">
                        <Link to='/expertise/architecture'>
                            <img
                                src={architecture}
                                alt="Architecture"
                                className="w-full h-72 object-cover transition-transform duration-700 ease-in-out hover:scale-105"
                            />
                            <div className="absolute bottom-0 left-0 p-4 bg-gradient-to-t from-black to-slate-500/5 w-full">
                                <p className="text-white text-xl text-left font-semibold">Architecture</p>
                            </div>
                        </Link>
                    </div>
                    <div className="bg-[#333333] p-6 flex items-center rounded-lg shadow-lg">
                        <p className="text-lg">
                            From the very beginning, our practice was founded on a philosophy of innovation, sustainability, and design. We continue to learn from the past and creatively embrace the challenges of the future, with a firm belief that good design makes a difference.
                            <br /><br />
                            <span className="font-bold">Architetive Designs</span>
                        </p>
                    </div>
                </div>
            </div>

            <ExpertiseSection />

            <div className="w-full px-4 md:px-14 text-white pb-14">
                <h1 className="text-3xl md:text-4xl font-bold mb-8">People</h1>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
                    <div className="relative col-span-1 md:col-span-2 rounded-lg overflow-hidden transition-transform duration-300 ease-in-out">
                        <Link to='/people'>
                            <img
                                src={PeopleImg}
                                alt="Climate and Sustainable Design"
                                className="w-full h-72 object-cover transition-transform duration-700 ease-in-out hover:scale-105"
                            />
                            <div className="absolute bottom-0 left-0 p-4 bg-gradient-to-t from-black to-slate-500/5 w-full">
                                <p className="text-white text-xl text-left font-semibold">People</p>
                            </div>
                        </Link>
                    </div>
                    <div className="bg-[#333333] p-6 flex items-center rounded-lg shadow-lg">
                        <p className="text-lg">
                            Our team of skilled architects, engineers, and construction experts is dedicated to transforming ideas into reality. With innovation, precision, and a commitment to excellence, we design and build spaces that inspire. From concept to completion, we bring expertise and passion to every project.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Home;